import { apiConstructor as api } from '@/api/apiConstructor';
import { AxiosResponse } from 'axios';

export async function getCarouselItems(contentId: string): Promise<string[]> {
  try {
    const response: AxiosResponse = await api.get(
      `content/${contentId}/carousel-items`,
    );
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function updateCarouselItems(
  contentId: string,
  itemIds: string[],
): Promise<void> {
  const response: AxiosResponse = await api.post(
    `content/${contentId}/carousel-items`,
    { itemIds },
  );
  return response.data;
}
